export enum APP_EVENTS {
  CREATE = 'Create',
  EDIT = 'Edit',
  DELETE = 'Delete',
}
